import { HelpCircle } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

type Props = {
  /** Treść dymka. Może zawierać znaki nowej linii (renderowane jako whitespace-pre-line). */
  text: string
  /** Rozmiar ikony "?" w pikselach. Domyślnie 12. */
  size?: number
  /** Dodatkowy className aplikowany do triggera (otoczki ikony). */
  className?: string
  /** Strona pojawiania się tooltipa względem ikony. Domyślnie 'top'. */
  side?: 'top' | 'right' | 'bottom' | 'left'
}

/**
 * Floating tooltip ze znaczkiem "?" do podpinania pod label pola formularza.
 * Używa globalnego {@code TooltipProvider} ustawionego w MainLayout.
 */
export function HelpTooltip({ text, size = 12, className, side = 'top' }: Props) {
  if (!text) return null
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Pomoc"
          tabIndex={-1}
          onClick={(e) => e.preventDefault()}
          className={cn(
            'inline-flex items-center text-slate-400 hover:text-slate-700 cursor-help',
            className,
          )}
        >
          <HelpCircle size={size} />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs whitespace-pre-line">
        {text}
      </TooltipContent>
    </Tooltip>
  )
}
